import React from "react";
import { styled } from "styled-components";
import ServiceNameWithEmphasis from "./ServiceNameWithEmphasis";

const IndividualBoxWrapper = styled.div`
  display: grid;
  align-items: stretch;
  grid-template-columns: 1fr 4.5rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.sm};
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: ${({ theme }) => theme.shadow.sm};
  transition: box-shadow ${({ theme }) => theme.transition};

  &:hover {
    box-shadow: ${({ theme }) => theme.shadow.md};
  }

  @media screen and (min-width: 1000px) {
    grid-template-columns: minmax(0, 1fr) 4.5rem;
    justify-content: center;
  }
`;

const ServiceBoxName = styled.span`
  padding: 1rem 1rem;
  font-size: 1rem;
  line-height: 1.45;
  background-color: ${({ theme }) => theme.colors.bgMuted};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.text};

  @media screen and (min-width: 1000px) {
    font-size: 0.95rem;
    white-space: normal;

    > span {
      flex-wrap: wrap;
    }
  }

  @media screen and (min-width: 1200px) {
    font-size: 1rem;
  }
`;

const ServicePrice = styled.span`
  display: flex;
  justify-content: center;
  font-size: 1.125rem;
  font-weight: 700;
  padding: 1rem 0.75rem;
  background-color: ${({ theme }) => theme.colors.servicePriceBg};
  color: ${({ theme }) => theme.colors.servicePriceText};
  align-items: center;
`;

const ServiceBox = ({ services }) => {
  return (
    <IndividualBoxWrapper>
      <ServiceBoxName>
        <ServiceNameWithEmphasis>{services.service}</ServiceNameWithEmphasis>
      </ServiceBoxName>
      <ServicePrice>${services.price}</ServicePrice>
    </IndividualBoxWrapper>
  );
};

export default ServiceBox;
